import type { Profile } from '../types';

// Prénom à afficher : first_name, repli sur le 1er mot de full_name, sinon vide.
export function displayFirstName(profile: Profile | null): string {
  return profile?.first_name?.trim() || profile?.full_name?.trim().split(' ')[0] || '';
}

// Initiales pour l'avatar : first+last, repli sur full_name, sinon emoji neutre.
export function initials(profile: Profile | null): string {
  const a = profile?.first_name?.trim()?.[0] ?? '';
  const b = profile?.last_name?.trim()?.[0] ?? '';
  const fromName = (a + b).toUpperCase();
  if (fromName) return fromName;

  const full = profile?.full_name?.trim();
  if (full) {
    return full
      .split(' ')
      .map((w) => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }
  return '🙂';
}
